import {
  AfterViewInit,
  Component,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { FormBuilder } from "@angular/forms";
import {
  AccountService,
  AlertService,
  CampaignProductService,
  CampaignService,
  CampaignTrackingService,
  CRMCampaignService,
  FunnelStepService,
  MerchantService,
  RefundReportService,
  ReportsConfigService,
  StorageService,
  UserService,
  CancelReasonCategoryService
} from "../_services";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { NgxSmartModalService } from "ngx-smart-modal";
import { ReportsAbstractV2Component } from "./reports-abstract-v2.component";
import { MultiOptions } from "../custom-multi-select/multi-select";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { fields, filters } from "./utils/constants";
import { cloneDeep } from "lodash";
import { ReportTypes } from "./models/reports";
import {Observable} from 'rxjs';

@Component({
  moduleId: module.id.toString(),
  selector: "refund-report-v2",
  templateUrl: "./templates/reports-v2.component.html",
  styleUrls: ["./styles/reports-v2.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class RefundReportV2Component
  extends ReportsAbstractV2Component
  implements OnInit, AfterViewInit
{
  reportTitle = "Refund Report";
  fields: MultiOptions = cloneDeep(fields);
  filters: MultiOptions = cloneDeep(filters);
  reportType = ReportTypes.REFUND;

  commonReportsFields = [
    "item_refund_quantity",
    "item_partial_refund_amount",
    "item_full_refund_amount",
    "item_save_amount",
  ];
  summaryFields = [
    "item_refund_quantity",
    "amount_paid",
    "save_amount",
    "item_refund_amount",
    "item_partial_refund_amount",
    "item_full_refund_amount",
    "refund_ratio",
    "save_ratio",
    'avg_refund_amount',
    'sessions'
  ];
  selectedDimensions = [
    {
      model: "product_path",
      label: "Customer Stage",
      selected: true,
      disabled: false,
    },
  ];
  showExcludeUpsellsFilter = true;

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected alertService: AlertService,
    protected formBuilder: FormBuilder,
    public reportsService: RefundReportService,
    protected modalService: NgxSmartModalService,
    protected campaignService: CampaignService,
    protected reportsConfigService: ReportsConfigService,
    protected trackingSourceService: CampaignTrackingService,
    protected userService: UserService,
    protected accountService: AccountService,
    protected campaignProductService: CampaignProductService,
    protected crmCampaignService: CRMCampaignService,
    protected storageService: StorageService,
    protected stepService: FunnelStepService,
    protected refundReportService: RefundReportService,
    protected merchantService: MerchantService,
    protected cancelReasonCategoryService: CancelReasonCategoryService
  ) {
    super(
      router,
      location,
      route,
      alertService,
      reportsService,
      campaignService,
      reportsConfigService,
      trackingSourceService,
      userService,
      accountService,
      campaignProductService,
      crmCampaignService,
      storageService,
      stepService,
      merchantService,
      modalService,
      cancelReasonCategoryService
    );

    this.updatePreSelectedDimensions("product_path");
    this.filterCommonDimensions(this.commonReportsFields);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewInit() {
    if (this.panel) {
      this.panel.expanded = true;
    }
  }

  drop(event: CdkDragDrop<string[]>): void {
    moveItemInArray(
      this.selectedDimensions,
      event.previousIndex,
      event.currentIndex
    );
  }

  getSummaryApiCalls(): Observable<any> {
    return this.reportsService.getSummary(this.getQueryForSummary())
  }
}
